module.exports = __webpack_public_path__ + "assets/download.51f874324f7dc0090253dc020559aa20.png";


//////////////////
// WEBPACK FOOTER
// ./img/download.png
// module id = 942
// module chunks = 0